export enum LoginModalTab {
  SignIn,
  SignUp,
}

export default LoginModalTab
